import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { Box } from '@material-ui/core';
import { varWrapEnter } from './Wrap';
export function MotionContainer({ open, children, ...other }) {
    return (_jsx(Box, Object.assign({ component: motion.div, initial: false, animate: open ? 'animate' : 'exit', variants: varWrapEnter }, other, { children: children }), void 0));
}
//# sourceMappingURL=MotionContainer.js.map